var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTjTajikistan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#006600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V32.1469H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V12.8531H60V0Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7998 21.8996C31.7115 21.7498 31.5771 21.6326 31.4167 21.5654C31.2563 21.4983 31.0785 21.4848 30.9098 21.527C30.7411 21.5691 30.5905 21.6647 30.4806 21.7995C30.3707 21.9342 30.3073 22.1009 30.2998 22.2746V25.4996H29.6998V22.284C29.6924 22.1102 29.6289 21.9436 29.519 21.8088C29.4091 21.6741 29.2585 21.5785 29.0898 21.5363C28.9211 21.4942 28.7433 21.5077 28.5829 21.5748C28.4225 21.642 28.2881 21.7592 28.1998 21.909C28.1068 21.6246 28.0826 21.3223 28.129 21.0268C28.1754 20.7313 28.2911 20.4509 28.4667 20.2088C28.6423 19.9666 28.8728 19.7695 29.1393 19.6336C29.4058 19.4976 29.7007 19.4268 29.9998 19.4268C30.2989 19.4268 30.5938 19.4976 30.8603 19.6336C31.1268 19.7695 31.3573 19.9666 31.5329 20.2088C31.7085 20.4509 31.8242 20.7313 31.8706 21.0268C31.917 21.3223 31.8928 21.6246 31.7998 21.909",
    fill: "#F8C300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3691 21.0653C31.1059 21.0109 30.8323 21.0404 30.5867 21.1497C30.3411 21.2591 30.1361 21.4427 30.0004 21.6747C29.8647 21.4427 29.6596 21.2591 29.4141 21.1497C29.1685 21.0404 28.8949 21.0109 28.6316 21.0653C28.671 20.7299 28.8321 20.4206 29.0844 20.1961C29.3367 19.9717 29.6627 19.8477 30.0004 19.8477C30.3381 19.8477 30.6641 19.9717 30.9164 20.1961C31.1687 20.4206 31.3298 20.7299 31.3691 21.0653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3 24.2158C30.3398 24.6727 30.5078 25.1091 30.7845 25.4749C31.0613 25.8406 31.4356 26.1208 31.8644 26.2834C32.2933 26.4459 32.7593 26.4841 33.209 26.3937C33.6586 26.3033 34.0736 26.0878 34.4062 25.7721C34.5473 26.1321 34.769 26.455 35.0543 26.7161C35.3396 26.9771 35.6809 27.1693 36.052 27.278C36.4231 27.3866 36.8142 27.4087 37.1952 27.3427C37.5762 27.2767 37.9371 27.1242 38.25 26.8971C38.0156 29.2408 34.5 28.7627 34.2375 26.4846C33.1406 28.4252 30.7125 27.8627 30 25.4908L30.3 24.2158Z",
    fill: "#F8C300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6438 28.3691C33.1406 29.4285 34.1156 29.6066 34.9688 28.7535C34.9688 28.7535 34.6312 28.5098 34.2562 28.4441C34.3312 28.1535 34.1906 27.741 33.9844 27.5254C33.7114 27.7045 33.5092 27.9729 33.4125 28.2848C32.8969 28.2191 32.6438 28.3785 32.6438 28.3785V28.3691Z",
    fill: "#F8C300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9131 31.2256C27.8852 30.0433 32.1156 30.0433 36.0876 31.2256L36.3818 30.2372C32.2178 28.9978 27.7829 28.9978 23.6189 30.2372L23.9131 31.2256Z",
    fill: "#F8C300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0296 16.7671L31.5703 14.9211H28.4298L30.9705 16.7671L30 13.7803L29.0296 16.7671Z",
    fill: "#F8C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTjTajikistan);
export default __webpack_public_path__ + "static/media/tj Tajikistan.9cdda0c983889b70424f6ec21d11d046.svg";
export { ForwardRef as ReactComponent };